const config = {
  environment: 'qa',
  api_url: 'https://qa.client-api.hotglue.xyz',
};

export default config;
